import "./work.scss";
import React from "react";

import useObserver from "../../utilities/UseObserver";

import SkillsCard from "../../components/Skills_Card/Skills_Card";
import GlassProject from "../../components/Glass_Project/Glass_Project";
import BlobBackground from "../../components/Blob_Backgound/Blob_Background";

const Work = () => {
  const [isIntersecting, refElement] = useObserver({
    rootMargin: "0px",
    root: null,
    threshold: 0.1,
  });

  let classNameEffect = isIntersecting ? "--in" : "--out";

  return (
    <section className="projects" id="proyectos-y-trabajos" ref={refElement}>
      <div
        className={`projects__blob-background projects__blob-background${classNameEffect}`}
      >
        <BlobBackground />
      </div>
      <div className={`projects__works projects__works${classNameEffect}`}>
        <GlassProject />
      </div>
      <div className={`projects__skills projects__skills${classNameEffect}`}>
        <SkillsCard />
      </div>
    </section>
  );
};

export default Work;
